import Currency from './components/Currency';
import './styles/App.css';

function App() {
  return <div className='header-name' >
    Currency App 
    <Currency/>
  </div>;
}

export default App;
